import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import ui from './modules/ui';
import popups from './modules/popups';
import settings from './modules/settings';
import products from './modules/products';
import lookups from './modules/lookups';
import branchContext from './modules/branchContext';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    ui,
    popups,
    settings,
    products,
    lookups,
    branchContext,
  },
});
